import { render, staticRenderFns } from "./AiGenerateButton.vue?vue&type=template&id=45c79e4f&scoped=true&"
import script from "./AiGenerateButton.vue?vue&type=script&lang=js&"
export * from "./AiGenerateButton.vue?vue&type=script&lang=js&"
import style0 from "./AiGenerateButton.vue?vue&type=style&index=0&id=45c79e4f&prod&scoped=true&lang=css&"
import style1 from "./AiGenerateButton.vue?vue&type=style&index=1&id=45c79e4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c79e4f",
  null
  
)

export default component.exports